<template>
    <div class="col margin-bottom-50 links">
        <ul class="list-unstyled">
            <li><a :href="block.link_url_1">{{ block.link_txt_1 }}</a></li>
            <li><a :href="block.link_url_2">{{ block.link_txt_2}}</a></li>
        </ul>
    </div>
</template>

<script>
import Block from "@/mixins/Block.js"

export default {
    mixins: [Block]
}
</script>